import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';

import { createGetAPI, createPostAPI } from '@cuemath/rest-api';

const { useGet: useTranscribeGet } = createGetAPI({
  getURL: (teacherClassroomId, query, meta) =>
    `${BASE_URL}/classroom/teacher-classroom/${teacherClassroomId}/transcribe?${stringify(
      query,
    )}`,
});

const { usePost: useTranscribePost } = createPostAPI({
  getURL: (_, { teacherClassroomId }) =>
    `${BASE_URL}/classroom/teacher-classroom/${teacherClassroomId}/transcribe/`,
});

export { useTranscribeGet, useTranscribePost };
